import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

// Import your images
import img1 from '../Images/HomeImages/img-1.png';
import img2 from '../Images/HomeImages/img-2.jpg';
import img3 from '../Images/HomeImages/img-3.jpg';
import img4 from '../Images/HomeImages/img-4.jpg'
// Styled components
const SliderContainer = styled.div`
  position: relative;
  width: 100%;
  height:100%;
  overflow: hidden;
  @media screen and (max-width:450px){
     height:180px;
  }
`;

const Slide = styled.div`
  display: flex;
  transition: transform 0.5s ease-in-out;
  transform: ${({ currentIndex }) => `translateX(-${currentIndex * 100}%)`};
  @media screen and (max-width:450px){
     height:180px;
  }
`;

const Image = styled.img`
  width: 100%;
  object-fit: cover;
object-position: center;
  
`;

const Arrow = styled.div`
  position: absolute;
  top: 50%;
  ${({ direction }) => direction === 'left' ? 'left: 10px' : 'right: 10px'};
  transform: translateY(-50%);
  font-size: 2rem;
  color: white;
  z-index: 10;
  cursor: pointer;
  user-select: none;
`;

const DotsContainer = styled.div`
  position: absolute;
  bottom: 10px;
  width: 100%;
  display: flex;
  justify-content: center;
`;

const Dot = styled.div`
  margin: 0 5px;
  cursor: pointer;
  font-size: ${({ isActive }) => (isActive ? '1.5rem' : '1rem')};
  color: ${({ isActive }) => (isActive ? 'black' : 'gray')};
`;

// Slider Component
const FirstSlider = () => {
    const images = [img1, img2, img3, img4];
    const [currentIndex, setCurrentIndex] = useState(0);

    const goToPrevious = () => {
        const isFirstSlide = currentIndex === 0;
        const newIndex = isFirstSlide ? images.length - 1 : currentIndex - 1;
        setCurrentIndex(newIndex);
    };

    const goToNext = () => {
        const isLastSlide = currentIndex === images.length - 1;
        const newIndex = isLastSlide ? 0 : currentIndex + 1;
        setCurrentIndex(newIndex);
    };

    const goToSlide = (index) => {
        setCurrentIndex(index);
    };

    useEffect(() => {
        const interval = setInterval(() => {
            goToNext();
        }, 3000); // Change slide every 3 seconds
        return () => clearInterval(interval);
    }, [currentIndex]);

    return (
        <SliderContainer>
            <Arrow direction="left" onClick={goToPrevious}>&#10094;</Arrow>
            <Slide currentIndex={currentIndex}>
                {images.map((image, index) => (
                    <Image key={index} src={image} alt={`Slide ${index + 1}`} />
                ))}
            </Slide>
            <Arrow direction="right" onClick={goToNext}>&#10095;</Arrow>
            <DotsContainer>
                {images.map((_, index) => (
                    <Dot
                        key={index}
                        isActive={currentIndex === index}
                        onClick={() => goToSlide(index)}
                    >
                        &bull;
                    </Dot>
                ))}
            </DotsContainer>
        </SliderContainer>
    );
};

export default FirstSlider;
